module.exports = __webpack_public_path__ + "static/media/GC01@xs.1c3b9d65.jpg";